module.exports = "/images/rw.svg?d8cde2406f6a05e8076215a17467720c";